<template lang="pug">
div(
    :class="styles.root"
)
    TheText(
        :class="styles.title"
        name="titleXL"
    ) Выберите банк или эл. кошелёк для оплаты
    BankCell(
        v-for="(bank, index) in banks"
        :class="styles.cell"
        v-bind="bank"
        :key="bank.id"
    )
</template>

<script lang="ts">
import Vue, { useCssModule } from 'vue'

import { TheText } from '@/shared/ui/TheText'

import { banks, BankCell } from './BankCell'

export default Vue.extend({
    name: 'BankListState',
    setup() {
        const styles = useCssModule()

        return {
            styles,
            banks,
        }
    },
    components: { TheText, BankCell },
})
</script>

<style module lang="scss" src="./BankListState.module.scss" />
